import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class ConfirDeletionPopupComponentData {
  title?: string;
  message: string;
}

@Component({
  selector: 'app-confirm-deletion-popup',
  templateUrl: './confirm-deletion-popup.component.html',
  styleUrls: ['./confirm-deletion-popup.component.scss']
})
export class ConfirmDeletionPopupComponent {
  title: string;
  message: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirDeletionPopupComponentData, public dialogRef: MatDialogRef<ConfirmDeletionPopupComponent>) {
    this.title = data.title;
    this.message = data.message;
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
